import { getRejectionList, getRejectionListNotifyEmails, setRejectionListNotifyEmails } from '@/api';

const getInitialState = () => ({
  rejectionList: [],
  notifyEmails: [],
});

export default {
  namespaced: true,
  state: getInitialState(),
  mutations: {
    setRejectionList(state, rejectionList) {
      state.rejectionList = rejectionList;
    },
    setNotifyEmails(state, notifyEmails) {
      state.notifyEmails = notifyEmails;
    },
    resetState(state) {
      Object.assign(state, getInitialState());
    },
  },
  actions: {
    async getList({ commit }) {
      const { data = [] } = await getRejectionList();
      commit('setRejectionList', data || []);
    },
    async getNotifyEmails({ commit }) {
      const { data } = await getRejectionListNotifyEmails();
      commit('setNotifyEmails', data?.emails || []);
    },
    async updateNotifyEmails({ commit }, payload) {
      const { data } = await setRejectionListNotifyEmails(payload);
      commit('setNotifyEmails', data?.emails || []);
    },
  },
};
